module.exports = __webpack_public_path__ + "img/sincerity_gold_admin.94c93b91.png";